import styled from "styled-components";

export const Container = styled.div`
  position: absolute;
  z-index: 1000;
  bottom: 1.5rem;
  right: 5.875rem;
  z-index: 999;

  > button {
    background: none;
    width: 3.125rem;
    height: 3.125rem;
    background: var(--black-100);
    align-self: flex-end;
    border-radius: 6.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const Popup = styled.div`
  position: absolute;
  right: 17.5rem;
  top: 1.25rem;
`;

export const ColorsContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 1rem;
`;

export const ColorInput = styled.input`
  &[type="color"] {
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    height: 2rem;
    cursor: pointer;
  }

  &[type="color"]::-webkit-color-swatch-wrapper {
    padding: 0;
  }
`;
